/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function DefaultFooter() {
  return (
    <>
      <footer className="footer footer-default">
        <Container>
          <nav>
            <ul>
              <li>
                <a
                  href="http://www.sssmt.org.in/pages/index.asp"
                  target="_blank"
                >
                  SSS Medical Care
                </a>
              </li>
              <li>
                <a
                  href="https://psg.sssihms.org.in/"
                  target="_blank"
                >
                  SSSIHMS, Prashanthi Gram 
                </a>
              </li>
              <li>
                <a
                  href="https://sssihms.org/"
                  target="_blank"
                >
                  SSIHMS, Whitefield
                </a>
              </li>
            </ul>
          </nav>
          <div className="copyright" id="copyright">
            Copyright © {new Date().getFullYear()}.{" "}
            <a
              href="https://ssssoindia.org/"
              target="_blank"
            >
              Sri Sathya Sai Seva Organisations
            </a>
            .  All rights reserved.{" "}            
          </div>
        </Container>
      </footer>
    </>
  );
}

export default DefaultFooter;
